window.bundleDataS = {
"Sadie-girl": {
displayName: "Sadie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Sadie Personalized Coloring Experience",
variantId: "49639683621101",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sadie_final_cover.png?v=1773501522",
price: "$14.99",
preorder: true
},
{
title: "Sadie Unicorn Holographic Sticker",
variantId: "49933755711725",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sadie_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Sadie Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Sage-girl": {
displayName: "Sage",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Sage Personalized Coloring Experience",
variantId: "49971429146861",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sage_final_cover.png?v=1775415513",
price: "$14.99",
preorder: true
},
{
title: "Sage Unicorn Holographic Sticker",
variantId: "49945853034733",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sage_holographic_sticker.png?v=1779378945",
price: "$4.99",
preorder: false
},
{
title: "Sage Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Sam-boy": {
displayName: "Sam",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Sam Personalized Coloring Experience",
variantId: "49657197789421",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sam_final_cover.png?v=1773501514",
price: "$14.99",
preorder: true
},
{
title: "Sam Dragon Holographic Sticker",
variantId: "49933754630381",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sam_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Sam Calling Gift Sticker",
variantId: "49933465977069",
image: "https://lkbunting.com/cdn/shop/files/4838A05A-04A0-4B87-B29E-D1DD51D0D666.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Samantha-girl": {
displayName: "Samantha",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Samantha Personalized Coloring Experience",
variantId: "49639911031021",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Samantha_final_cover.png?v=1773501522",
price: "$14.99",
preorder: true
},
{
title: "Samantha Unicorn Holographic Sticker",
variantId: "49933755515117",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Samantha_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Samantha Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Samuel-boy": {
displayName: "Samuel",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Samuel Personalized Coloring Experience",
variantId: "49411988193517",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/SAMUEL_FINAL_COVER.png?v=1772032668",
price: "$14.99",
preorder: true
},
{
title: "Samuel Dragon Holographic Sticker",
variantId: "49933766983917",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Samuel_holographic_sticker.png?v=1780106108",
price: "$4.99",
preorder: false
},
{
title: "Samuel Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Santiago-boy": {
displayName: "Santiago",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Santiago Personalized Coloring Experience",
variantId: "49400191451373",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Santiago_final_cover.png?v=1771691708",
price: "$14.99",
preorder: true
},
{
title: "Santiago Dragon Holographic Sticker",
variantId: "49933768884461",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Santiago_holographic_sticker.png?v=1780106104",
price: "$4.99",
preorder: false
},
{
title: "Santiago Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Saoirse-girl": {
displayName: "Saoirse",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Saoirse Personalized Coloring Experience",
variantId: "49801330557165",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Saoirse_final_cover.png?v=1775415417",
price: "$14.99",
preorder: true
},
{
title: "Saoirse Unicorn Holographic Sticker",
variantId: "49933746307309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Saoirse_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Saoirse Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Sara-girl": {
displayName: "Sara",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Sara Personalized Coloring Experience",
variantId: "49272707547373",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sara_final_cover.png?v=1773766536",
price: "$14.99",
preorder: true
},
{
title: "Sara Unicorn Holographic Sticker",
variantId: "49933781041389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sara_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Sara Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Sarah-girl": {
displayName: "Sarah",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Sarah Personalized Coloring Experience",
variantId: "49648288661741",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sarah_final_cover.png?v=1773501521",
price: "$14.99",
preorder: true
},
{
title: "Sarah Unicorn Holographic Sticker",
variantId: "49933755056365",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sarah_holographic_sticker.png?v=1780099048",
price: "$4.99",
preorder: false
},
{
title: "Sarah Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Sasha-girl": {
displayName: "Sasha",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Sasha Personalized Coloring Experience",
variantId: "49647438561517",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sashafinalcover.png?v=1773550871",
price: "$14.99",
preorder: true
},
{
title: "Sasha Unicorn Holographic Sticker",
variantId: "49933755318509",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sasha_holographic_sticker.png?v=1780099044",
price: "$4.99",
preorder: false
},
{
title: "Sasha Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Saskia-girl": {
displayName: "Saskia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Saskia Personalized Coloring Experience",
variantId: "49971428229357",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Saskia_final_cover.png?v=1775415513",
price: "$14.99",
preorder: true
},
{
title: "Saskia Unicorn Holographic Sticker",
variantId: "49945847824621",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Saskia_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Saskia Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Savannah-girl": {
displayName: "Savannah",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Savannah Personalized Coloring Experience",
variantId: "49279573197037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Savannah_final_cover.png?v=1772908492",
price: "$14.99",
preorder: true
},
{
title: "Savannah Unicorn Holographic Sticker",
variantId: "49933773897965",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Savannah_holographic_sticker.png?v=1780099045",
price: "$4.99",
preorder: false
},
{
title: "Savannah Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Sawyer-boy": {
displayName: "Sawyer",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Sawyer Personalized Coloring Experience",
variantId: "49274734248173",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sawyer_final_cover.png?v=1771691708",
price: "$14.99",
preorder: true
},
{
title: "Sawyer Dragon Holographic Sticker",
variantId: "49933780386029",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sawyer_holographic_sticker.png?v=1780106105",
price: "$4.99",
preorder: false
},
{
title: "Sawyer Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Scarlett-girl": {
displayName: "Scarlett",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Scarlett Personalized Coloring Experience",
variantId: "49279573295341",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Scarlett_final_cover.png?v=1773766538",
price: "$14.99",
preorder: true
},
{
title: "Scarlett Unicorn Holographic Sticker",
variantId: "49933773865197",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Scarlett_holographic_sticker.png?v=1780099045",
price: "$4.99",
preorder: false
},
{
title: "Scarlett Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Scott-boy": {
displayName: "Scott",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Scott Personalized Coloring Experience",
variantId: "49400126406893",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Scott_final_cover.png?v=1771691586",
price: "$14.99",
preorder: true
},
{
title: "Scott Dragon Holographic Sticker",
variantId: "49933769998573",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Scott_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Scott Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Sean-boy": {
displayName: "Sean",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Sean Personalized Coloring Experience",
variantId: "49400170414317",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sean_final_cover.png?v=1771691712",
price: "$14.99",
preorder: true
},
{
title: "Sean Dragon Holographic Sticker",
variantId: "49933769015533",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sean_holographic_sticker.png?v=1780106103",
price: "$4.99",
preorder: false
},
{
title: "Sean Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Sebastian-boy": {
displayName: "Sebastian",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Sebastian Personalized Coloring Experience",
variantId: "49263860482285",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sebastian_final_cover.png?v=1772753295",
price: "$14.99",
preorder: true
},
{
title: "Sebastian Dragon Holographic Sticker",
variantId: "49933781827821",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sebastian_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Sebastian Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Senna-girl": {
displayName: "Senna",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Senna Personalized Coloring Experience",
variantId: "49650663555309",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Senna_final_cover.png?v=1773501522",
price: "$14.99",
preorder: true
},
{
title: "Senna Unicorn Holographic Sticker",
variantId: "49933754990829",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Senna_holographic_sticker.png?v=1780099048",
price: "$4.99",
preorder: false
},
{
title: "Senna Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,

"Seraphina-girl": {
displayName: "Seraphina",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Seraphina Personalized Coloring Experience",
variantId: "49929678029037",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Seraphina_final_cover.png?v=1775415417",
price: "$14.99",
preorder: true
},
{
title: "Seraphina Unicorn Holographic Sticker",
variantId: "49933745651949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Seraphina_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Seraphina Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Shawn-boy": {
displayName: "Shawn",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Shawn Personalized Coloring Experience",
variantId: "49400169234669",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Shawn_final_cover.png?v=1771691711",
price: "$14.99",
preorder: true
},
{
title: "Shawn Dragon Holographic Sticker",
variantId: "49933769048301",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Shawn_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Shawn Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Sienna-girl": {
displayName: "Sienna",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Sienna Personalized Coloring Experience",
variantId: "49402681393389",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/SIENNAFINALCOVER.png?v=1771818773",
price: "$14.99",
preorder: true
},
{
title: "Sienna Unicorn Holographic Sticker",
variantId: "50043559117037",
image: "https://lkbunting.com/cdn/shop/files/Sienna_holographic_sticker.png?v=1780099048&width=493",
price: "$4.99",
preorder: false
},
{
title: "Sienna Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Silas-boy": {
displayName: "Silas",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Silas Personalized Coloring Experience",
variantId: "49279573623021",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Silasfinalcover.png?v=1771571789",
price: "$14.99",
preorder: true
},
{
title: "Silas Dragon Holographic Sticker",
variantId: "49933773832429",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Silas_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Silas Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Simon-boy": {
displayName: "Simon",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Simon Personalized Coloring Experience",
variantId: "49709375488237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Simon_final_cover.png?v=1774104747",
price: "$14.99",
preorder: true
},
{
title: "Simon Dragon Holographic Sticker",
variantId: "49933753843949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Simon_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Simon Calling Gift Sticker",
variantId: "49933465321709",
image: "https://lkbunting.com/cdn/shop/files/B63C54D9-D4D2-447F-AA7C-3156B1E686E7.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Skylar-girl": {
displayName: "Skylar",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Skylar Personalized Coloring Experience",
variantId: "49651094946029",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Skylar_final_cover.png?v=1773501523",
price: "$14.99",
preorder: true
},
{
title: "Skylar Unicorn Holographic Sticker",
variantId: "49933754958061",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Skylar_holographic_sticker.png?v=1780099045",
price: "$4.99",
preorder: false
},
{
title: "Skylar Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Sloane-girl": {
displayName: "Sloane",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Sloane Personalized Coloring Experience",
variantId: "49279573754093",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sloane_final_cover.png?v=1773766536",
price: "$14.99",
preorder: true
},
{
title: "Sloane Unicorn Holographic Sticker",
variantId: "49933773799661",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sloane_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Sloane Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Sofia-girl": {
displayName: "Sofia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Sofia Personalized Coloring Experience",
variantId: "49640173895917",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sofia_final_cover.png?v=1773501523",
price: "$14.99",
preorder: true
},
{
title: "Sofia Unicorn Holographic Sticker",
variantId: "49933755482349",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sofia_holographic_sticker.png?v=1780099050",
price: "$4.99",
preorder: false
},
{
title: "Sofia Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Sophia-girl": {
displayName: "Sophia",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Sophia Personalized Coloring Experience",
variantId: "49640652800237",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sophia_final_cover.png?v=1773501521",
price: "$14.99",
preorder: true
},
{
title: "Sophia Unicorn Holographic Sticker",
variantId: "49933755449581",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sophia_holographic_sticker.png?v=1780099049",
price: "$4.99",
preorder: false
},
{
title: "Sophia Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Sophie-girl": {
displayName: "Sophie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Sophie Personalized Coloring Experience",
variantId: "49652269875437",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sophie_final_cover.png?v=1773501522",
price: "$14.99",
preorder: true
},
{
title: "Sophie Unicorn Holographic Sticker",
variantId: "49933754925293",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sophie_holographic_sticker.png?v=1780099044",
price: "$4.99",
preorder: false
},
{
title: "Sophie Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Soren-boy": {
displayName: "Soren",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Soren Personalized Coloring Experience",
variantId: "49299075858669",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Soren_final_cover.png?v=1772753296",
price: "$14.99",
preorder: true
},
{
title: "Soren Dragon Holographic Sticker",
variantId: "49933772587245",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Soren_holographic_sticker.png?v=1780106110",
price: "$4.99",
preorder: false
},
{
title: "Soren Calling Gift Sticker",
variantId: "49933463617773",
image: "https://lkbunting.com/cdn/shop/files/BD75B2EC-A7BE-4460-8B0C-3995A3F132D4.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Stacey-girl": {
displayName: "Stacey",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Stacey Personalized Coloring Experience",
variantId: "49983115722989",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Staceyfinalcover.png?v=1779026862",
price: "$14.99",
preorder: true
},
{
title: "Stacey Unicorn Holographic Sticker",
variantId: "49983090163949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Stacey_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Stacey Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Stacy-girl": {
displayName: "Stacy",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Stacy Personalized Coloring Experience",
variantId: "49983113855213",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Stacyfinalcover.png?v=1779026862",
price: "$14.99",
preorder: true
},
{
title: "Stacy Unicorn Holographic Sticker",
variantId: "49983089115373",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Stacy_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Stacy Calling Gift Sticker",
variantId: "49933475119341",
image: "https://lkbunting.com/cdn/shop/files/75F0D962-2AFD-484F-9265-459DE3145DDE.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Stella-girl": {
displayName: "Stella",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Stella Personalized Coloring Experience",
variantId: "49643497160941",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Stella_final_cover.png?v=1773501521",
price: "$14.99",
preorder: true
},
{
title: "Stella Unicorn Holographic Sticker",
variantId: "49933755416813",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Stella_holographic_sticker.png?v=1780099051",
price: "$4.99",
preorder: false
},
{
title: "Stella Calling Gift Sticker",
variantId: "49933475414253",
image: "https://lkbunting.com/cdn/shop/files/7110C924-5ECA-4490-9943-5293A51A8297.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Stephanie-girl": {
displayName: "Stephanie",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Stephanie Personalized Coloring Experience",
variantId: "49402725925101",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/STEPHANIEFINALCOVER.png?v=1771820484",
price: "$14.99",
preorder: true
},
{
title: "Stephanie Unicorn Holographic Sticker",
variantId: "49933767835885",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Stephanie_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Stephanie Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Stetson-boy": {
displayName: "Stetson",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Stetson Personalized Coloring Experience",
variantId: "49472174227693",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Stetson_final_cover.png?v=1772930018",
price: "$14.99",
preorder: true
},
{
title: "Stetson Dragon Holographic Sticker",
variantId: "49933759152365",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Stetson_holographic_sticker.png?v=1780106109",
price: "$4.99",
preorder: false
},
{
title: "Stetson Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Steve-boy": {
displayName: "Steve",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Steve Personalized Coloring Experience",
variantId: "49709326696685",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Steve_final_cover.png?v=1774104747",
price: "$14.99",
preorder: true
},
{
title: "Steve Dragon Holographic Sticker",
variantId: "49933754007789",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Steve_holographic_sticker.png?v=1780106109",
price: "$4.99",
preorder: false
},
{
title: "Steve Calling Gift Sticker",
variantId: "49933465059565",
image: "https://lkbunting.com/cdn/shop/files/2902703A-0C22-4788-A98F-911DD470074F.png?v=1778027230&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Steven-boy": {
displayName: "Steven",
gender: "Boy",
bundleType: "Dragon Bundle",
bookIsBundleItem: true,
items: [
{
title: "Steven Personalized Coloring Experience",
variantId: "49411990225133",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/STEVEN_FINAL_COVER.png?v=1772032669",
price: "$14.99",
preorder: true
},
{
title: "Steven Dragon Holographic Sticker",
variantId: "49933766951149",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Steven_holographic_sticker.png?v=1780106111",
price: "$4.99",
preorder: false
},
{
title: "Steven Calling Gift Sticker",
variantId: "49931373674733",
image: "https://lkbunting.com/cdn/shop/files/C887F02E-7A62-4EEB-9AB2-9E91DB6D58DF.png?v=1777945962&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Hero Journal",
variantId: "49472211484909",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers.png?v=1772946112&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Wilderreach",
variantId: "49931376492781",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/ChatGPT_Image_May_9_2026_12_32_43_PM.png?v=1778654016",
price: "$19.99",
preorder: true
}
]
} ,
"Susan-girl": {
displayName: "Susan",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Susan Personalized Coloring Experience",
variantId: "49983116378349",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Susan_final_cover.png?v=1779029043",
price: "$14.99",
preorder: true
},
{
title: "Susan Unicorn Holographic Sticker",
variantId: "49983091310829",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Susan_holographic_sticker.png?v=1779378944",
price: "$4.99",
preorder: false
},
{
title: "Susan Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} ,
"Sutton-girl": {
displayName: "Sutton",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Sutton Personalized Coloring Experience",
variantId: "49754352877805",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sutton_final_cover.png?v=1775322361",
price: "$14.99",
preorder: true
},
{
title: "Sutton Unicorn Holographic Sticker",
variantId: "49933753024749",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Sutton_holographic_sticker.png?v=1780099048",
price: "$4.99",
preorder: false
},
{
title: "Sutton Calling Gift Sticker",
variantId: "49933476167917",
image: "https://lkbunting.com/cdn/shop/files/A7B9C9D3-6947-4D40-92ED-A4BB6DA62635.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Serenity-girl": {
displayName: "Serenity",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Serenity Personalized Coloring Experience",
variantId: "50056823537901",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Serenity_final_cover.png?v=1780209145",
price: "$14.99",
preorder: true
},
{
title: "Serenity Unicorn Holographic Sticker",
variantId: "50056913584365",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Serenity_holographic_sticker.png?v=1780206654",
price: "$4.99",
preorder: false
},
{
title: "Serenity Calling Gift Sticker",
variantId: "49933474889965",
image: "https://lkbunting.com/cdn/shop/files/064E5E1E-C33B-4C50-962A-C5D15CF17BF1.png?v=1778027231&width=494",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Summer-girl": {
displayName: "Summer",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Summer Personalized Coloring Experience",
variantId: "50246058508525",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Summer_final_cover.png?v=1783566389",
price: "$14.99",
preorder: true
},
{
title: "Summer Unicorn Holographic Sticker",
variantId: "50259959283949",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Summer_holographic_sticker.png?v=1783785472",
price: "$4.99",
preorder: false
},
{
title: "Summer Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Selena-girl": {
displayName: "Selena",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Selena Personalized Coloring Experience",
variantId: "50594779660525",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Selena_final_cover.png?v=1788156781",
price: "$14.99",
preorder: true
},
{
title: "Selena Unicorn Holographic Sticker",
variantId: "50604079382765",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Selena_holographic_sticker.png?v=1788224572",
price: "$4.99",
preorder: false
},
{
title: "Selena Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
},
"Saylor-girl": {
displayName: "Saylor",
gender: "Girl",
bundleType: "Unicorn Bundle",
bookIsBundleItem: true,
items: [
{
title: "Saylor Personalized Coloring Experience",
variantId: "50643936280813",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Saylor_final_cover.png?v=1788490621",
price: "$14.99",
preorder: true
},
{
title: "Saylor Unicorn Holographic Sticker",
variantId: "50643948306669",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/Saylor_holographic_sticker.png?v=1788490590",
price: "$4.99",
preorder: false
},
{
title: "Saylor Calling Gift Sticker",
variantId: "49933477052653",
image: "https://lkbunting.com/cdn/shop/files/56A41B4B-25E3-469F-AA9F-BEB14166F9C4.png?v=1778027231&width=493",
price: "$4.99",
preorder: false
},
{
title: "Young Dreamer Journal",
variantId: "49472211058925",
image: "https://lkbunting.com/cdn/shop/files/Wilderreach_and_Willowmere_Journal_covers_1.png?v=1772946153&width=600",
price: "$11.99",
preorder: true
},
{
title: "The Five Callings of Willowmere",
variantId: "49933407846637",
image: "https://cdn.shopify.com/s/files/1/0793/6835/6077/files/TheFiveCallingsofWillowmerebookimage.png?v=1778023836",
price: "$19.99",
preorder: true
}
]
} 





};